export enum TicketPrioridad {
    ALTA='Alta', 
    MEDIA='Media',
    BAJA='Baja',
}
